import { CheckCircle2, Mail } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * Public page shown after a guest completes Stripe checkout. The enrollment
 * code is emailed asynchronously (via the Stripe webhook), so this page tells
 * the buyer what to do next rather than confirming the code itself.
 */
export default function CheckoutSuccessPage() {
  return (
    <div className="min-h-screen bg-sidebar flex items-center justify-center p-4">
      <div className="bg-white/10 backdrop-blur-sm p-12 rounded-2xl shadow-xl max-w-md w-full border border-white/10 text-center">
        <div className="mb-6 flex justify-center">
          <CheckCircle2 className="w-14 h-14 text-green-400" />
        </div>

        <h1 className="text-2xl font-bold text-white mb-2">Payment successful</h1>
        <p className="text-white/60 mb-8">Your seat is reserved. Here's what happens next.</p>

        <div className="text-left space-y-4 mb-8">
          <div className="flex gap-3">
            <Mail className="w-5 h-5 text-white/70 shrink-0 mt-0.5" />
            <p className="text-white/80 text-sm">
              <span className="font-semibold text-white">Check your email.</span> We've sent a
              single-use enrollment code to the address you used at checkout. (It can take a minute
              to arrive — check spam too.)
            </p>
          </div>
          <div className="flex gap-3">
            <span className="w-5 h-5 text-white/70 shrink-0 mt-0.5 font-bold text-center">2</span>
            <p className="text-white/80 text-sm">
              <span className="font-semibold text-white">Open the link in that email</span> (or use
              the button below) to create your account and redeem your code.
            </p>
          </div>
          <div className="flex gap-3">
            <span className="w-5 h-5 text-white/70 shrink-0 mt-0.5 font-bold text-center">3</span>
            <p className="text-white/80 text-sm">
              <span className="font-semibold text-white">Access the programme</span> — once
              redeemed, you're enrolled and ready to start.
            </p>
          </div>
        </div>

        <Link
          to="/redeem"
          className="block w-full bg-white text-sidebar px-6 py-3 rounded-xl font-bold hover:bg-white/90 transition-colors mb-3"
        >
          Redeem my code
        </Link>
        <Link
          to="/sign-in"
          className="block w-full bg-transparent border border-white/30 text-white px-6 py-3 rounded-xl font-semibold hover:bg-white/10 transition-colors"
        >
          Already have an account? Sign in
        </Link>
      </div>
    </div>
  );
}
